import React from "react";
import { ListElement } from "utils/types/util.types";
import TimelineItem from "components/MainPage/TimelineItem";
import { useScreenSize } from "utils/hooks/useScreenSize";
import { useTranslation } from "react-i18next";
import { isArray } from "utils/types/typeguards";

enum Side {
	LEFT = "LEFT",
	RIGHT = "RIGHT",
}

function Timeline() {

	const { t }  = useTranslation();

	const timelineElements = t([ `mainPage.whyUs.elements`, "" ], { returnObjects: true }) as ListElement[] | string;

	const getTimeLineElements = (side?: Side) => {
		if (!isArray(timelineElements)) return [];
		if (side === Side.LEFT) return (
			timelineElements
				.map((item, index) =>
					<TimelineItem
						key={ index }
						number={ index + 1 }
						description={ item.description }
						title={ item.title }/>
				)
				.filter((_, index) => index % 2 === 0)
		)
		if (side === Side.RIGHT) return (
			timelineElements
				.map((item, index) =>
					<TimelineItem
						key={ index }
						number={ index + 1 }
						description={ item.description }
						title={ item.title }/>
				)
				.filter((_, index) => index % 2 !== 0)
		)
		return timelineElements
			.map((item, index) =>
				<TimelineItem
					key={ index }
					number={ index + 1 }
					description={ item.description }
					title={ item.title }/>
			);
	}

	const screenSize = useScreenSize();

	return (
		<div className="flex mt-6">
			{
				screenSize.width > 768
					?
					<>
						<div className="flex flex-col gap-[60px] py-[60px] w-1/2">
							{ getTimeLineElements(Side.LEFT) }
						</div>
						<div className="w-0.5 bg-teal-300 h-full mx-10 hidden md:block"></div>
						<div className="flex flex-col gap-[60px] pt-[60px] w-1/2 mt-16">
							{ getTimeLineElements(Side.RIGHT) }
						</div>
					</>
					:
					<div className="flex flex-col gap-6 w-full">
						{ getTimeLineElements() }
					</div>
			}
		</div>
	);
}

export default Timeline;